import React, { Component } from 'react';
import Media from 'react-media';
import classes from './TupleStacked.scss';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { arrivalDuration } from '../../../utility';

// import Tag from '../../UI/Tag/Tag';
import Arrow from '../../UI/Arrow/Arrow';

// Airline
import AirlineWrapper from '../Wrappers/AirlineWrapper/AirlineWrapper';
import AirlineLogo from '../Airline/AirlineLogo/AirlineLogo';
import AirlineName from '../Airline/AirlineName/AirlineName';
import AirlineCode from '../Airline/AirlineCode/AirlineCode';

// Stopover
import StopoverWrapper from '../Wrappers/StopoverWrapper/StopoverWrapper';
import AirlineStopover from '../Airline/AirlineStopover/AirlineStopover';

// Duration
import DurationWrapper from '../Wrappers/DurationWrapper/DurationWrapper';

// Timing
import TimingWrapper from '../Wrappers/TimingWrapper/TimingWrapper';
import AirlineTiming from '../Airline/AirlineTiming/AirlineTiming';

import AirlinePrice from '../Airline/AirlinePrice/AirlinePrice';
import AirlineRefundable from '../Airline/AirlineRefundable/AirlineRefundable';

import AnimakitExpander from 'animakit-expander';
import TupleInner from '../../Flight/Tuple/TupleInner/TupleInner';

import * as fareRuleActions from '../../../store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class TupleStacked extends Component {
    rules = null;
    rulesCounter = null;

    state = {
        tabIndex: 1,
        isTupleExpanded: false
      };

      pricingHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.setState(prevState => {
          return { isTupleExpanded: !prevState.isTupleExpanded }
        });
      };

      switchTabHandler = (val) => {
        if (val === 2) {
            if (this.props.isIntFlight) {
                const params = new URLSearchParams(this.props.location.search);
                const sc = this.props.type === "onward" ? params.get('sc').split(',')[0] : params.get('sc').split(',')[1];
                const searchId = this.props.searchId;
                const flightId = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
                const fareRules = this.props.fareRules;
                let match = false;
                fareRules.forEach((element) => {
                  if (element.id === this.props.flightId) {
                    match = true;
                    this.rules = element.rules;
                  }
                })
                if (!match) {
                  const fareRuleParams = { sc: sc, flightIdCSV: flightId, searchId: searchId }
                  this.rulesCounter = this.props.rulesCounter;
                  this.props.onGetIntFareRules(fareRuleParams, flightId);
                }
            } else {
                const params = new URLSearchParams(this.props.location.search);
                const flightSchedule = this.props.type === "onward" ? this.props.flightScheduleOnward : this.props.flightScheduleReturn;
                const sc = this.props.type === "onward" ? params.get('sc').split(',')[0] : params.get('sc').split(',')[1];
                const flightId = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
                const supplierCode = sc;
                const searchId = this.props.searchId;
                const fareBasisCode = flightSchedule[0].FS[0].fbc;
                const airlineCode = flightSchedule[0].FS[0].ac;
                const resBookDesigCode = flightSchedule[0].FS[0].resBookDesigCode;
                const cabin = flightSchedule[0].FS[0].classtype;
                const fareRules = this.props.fareRules;
                let match = false;
                fareRules.forEach((element) => {
                if (element.id === flightId) {
                    match = true;
                    this.rules = element.rules;
                }
                })
                if (!match) {
                const fareRuleParams =  {
                    flightIdCSV: flightId,
                    supplierCode: supplierCode,
                    searchId: searchId,
                    fareBasisCode: fareBasisCode,
                    AirlineCode: airlineCode,
                    resBookDesigCode: resBookDesigCode,
                    cabin: cabin
                }
                this.rulesCounter = this.props.rulesCounter;
                this.props.onGetFareRules(fareRuleParams, flightId);
                }
            }
        }
        if (val === 3) {
            if (this.props.isIntFlight) {
                const params = new URLSearchParams(this.props.location.search);
                const searchId = this.props.searchId;
                const flightIdCSV = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
                const sc = this.props.type === "onward" ? params.get('sc').split(',')[0] : params.get('sc').split(',')[1];
        
                const baggageParams = {
                  searchId: searchId,
                  flightIdCSV: flightIdCSV,
                  sc: sc
                }
                this.props.onGetBaggageInfo(baggageParams);
            }
        }
        this.setState({
          tabIndex: val
        })
      }

    render() {
        const params = new URLSearchParams(this.props.location.search);
        const flightSchedule = this.props.type === "onward" ? this.props.flightScheduleOnward : this.props.flightScheduleReturn;
        const fareDetails = this.props.type === "onward" ? this.props.fareDetailsOnward : this.props.fareDetailsReturn;
        const tdu = this.props.type === "onward" ? this.props.tduOnward : this.props.tduReturn;
        const loa = this.props.type === "onward" ? this.props.loaOnward : this.props.loaReturn;
        const flightId = this.props.type === "onward" ? params.get("flightIdCSV").split(',')[0] : params.get("flightIdCSV").split(',')[1];
        const FS = flightSchedule[0].FS;
        const airlineCode = FS[0].ac;
        const OD = flightSchedule[0];
        const TF = fareDetails.revisedFareDetails.tf;

        if (this.props.rulesCounter > this.rulesCounter) {
          this.props.fareRules.forEach((element) => {
            if (element.id === flightId) {
              this.rules = element.rules;
            }
          });
        }

        const border = '1px dashed var(--color-border)';

        return (
            <React.Fragment>
                <div className={classes.Container} 
                        onClick={this.pricingHandler} 
                        style={{
                            borderBottom: this.state.isTupleExpanded ? `${border}` : 'none',
                            borderBottomLeftRadius: window.innerWidth > 600 && this.props.location.pathname.trim('').includes('/reviews') && this.props.tripType === "roundTripOnward" ? '0' : '4px',
                            borderBottomRightRadius: window.innerWidth > 600 && this.props.location.pathname.trim('').includes('/reviews') && this.props.tripType === "roundTripOnward" ? '0' : '4px',
                            marginBottom: window.innerWidth > 600 && this.props.location.pathname.trim('').includes('/reviews') && this.props.tripType === "roundTripOnward" ? '1px' : '0',
                            borderTopLeftRadius: window.innerWidth > 600 && this.props.location.pathname.trim('').includes('/reviews') && this.props.tripType === "roundTripReturn" ? '0' : '4px',
                            borderTopRightRadius: window.innerWidth > 600 && this.props.location.pathname.trim('').includes('/reviews') && this.props.tripType === "roundTripReturn" ? '0' : '4px',
                        }}>
                    <div style={{flex: this.props.location.pathname.trim('').includes('/reviews') ? '0 0 70%' : '0 0 62%'}} className={classes.ContainerPrimary}>
                        <AirlineWrapper style={{justifyContent: 'flex-start'}}>
                            <AirlineLogo airlineCode={airlineCode} />
                            <p className={classes.AirlineDetail}>
                                <AirlineName FS={FS} airlineNames={this.props.airlineNames} />
                                <AirlineCode FS={FS} />
                            </p>
                        </AirlineWrapper>
                        <Media query="(max-width: 599px)">
                            {matches =>
                                matches ? <div className={classes.DashedBorder}></div>: null}
                        </Media>
                        <Media query="(min-width: 599px)">
                                {matches =>
                                    matches ? (
                                        <TimingWrapper style={{
                                            flex: this.props.location.pathname.trim('').includes('/flights/search') ? window.innerWidth > 1200 ? '0 0 35%' : '0 0 41%' : '0 0 38%',
                                            marginRight: '8rem'
                                            }}>
                                            <div
                                            className="u-flex f-column justify-content-between align-items-start" 
                                            style={{width: '40%'}}>
                                                <div className={`u-fontSizeMedium u-textColorDark`}>{this.props.cityNames[this.props.type === "onward" ? this.props.isIntFlight ? this.props.idac : this.props.origin : this.props.isIntFlight ? this.props.iaac : this.props.destination]}</div>
                                                <AirlineTiming>{FS[0].dd}</AirlineTiming>
                                            </div>
                                            <Arrow style={{alignSelf: 'flex-start', lineHeight: 'inherit'}}/>
                                            <div style={{ width: '40%' }} className={`u-flex f-column justify-content-between align-items-end`}>
                                                <div className={`u-fontSizeMedium u-textColorDark`}>{this.props.cityNames[this.props.type === "onward" ? this.props.isIntFlight ? this.props.iaac : this.props.destination : this.props.isIntFlight ? this.props.idac : this.props.origin]}</div>
                                                <AirlineTiming>
                                                    {FS[FS.length -1].ad}
                                                </AirlineTiming>
                                            </div>
                                        </TimingWrapper>
                                    ) : (
                                        <TimingWrapper>
                                            <AirlineTiming>{FS[0].dd}</AirlineTiming>
                                            <Arrow />
                                            <AirlineTiming>
                                                {arrivalDuration(flightSchedule)}
                                            </AirlineTiming>
                                        </TimingWrapper>
                                    )}
                        </Media>
                        <Media query="(min-width: 599px)">
                            {matches =>
                                matches ? (
                                    <div className={`u-flex f-column justify-content-between u-textAlignRight`} style={{
                                        minWidth: '6rem'
                                    }}>
                                        <DurationWrapper style={{lineHeight: '1', marginBottom: '5px', marginRight: '0'}}>
                                            {tdu ? <span className={`u-textColorLight u-fontSize13`}>{tdu.substring(0, 2) + "h " + tdu.substring(3, 5) + "m"}</span> : null}
                                        </DurationWrapper>
                                        <StopoverWrapper>
                                            <AirlineStopover cityNames={this.props.cityNames} loa={loa} OD={OD} FS={FS} />
                                        </StopoverWrapper>
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <DurationWrapper style={{marginRight: '0'}}>
                                            <span className={`u-textColorLight u-fontSize13`}>{tdu.substring(0, 2) + "h " + tdu.substring(3, 5) + "m"}</span>
                                        </DurationWrapper>
                                        <StopoverWrapper>
                                            <AirlineStopover cityNames={this.props.cityNames} loa={loa} OD={OD} FS={FS} />
                                        </StopoverWrapper>
                                    </React.Fragment>
                                )}
                        </Media>
                    </div>
                    <div className={classes.ContainerSecondary}>
                        <div style={{display: this.props.location.pathname.trim('').includes('/reviews') ? 'none' : 'flex'}} className={classes.Box1}>
                                <div>
                                    <AirlinePrice tf={TF} />
                                </div>
                                <div style={{order: window.innerWidth > 600 ? '-1' : '0' }} className={classes.RefundType}>
                                    <AirlineRefundable FS={FS} />
                                </div>
                        </div>
                        <div className={classes.Box2}>
                            <span className={classes.Details}>Details</span>
                            <span className={`u-fontSize13 u-textColorPrimary u-cursorPointer u-phoneHide`}>View Details</span>
                            <div style={{ transform: this.state.isTupleExpanded ? 'rotate(-180deg)' : 'rotate(0deg)' }} className={`u-cursorPointer u-phoneHide ml-3 u-transition--transform200Spring`}>
                                  <FontAwesomeIcon icon="angle-down" color="#666" size="lg" />
                            </div>
                        </div>
                    </div>
                </div>
                <AnimakitExpander
                    expanded={this.state.isTupleExpanded}
                    duration={400}
                    align="top"
                >
                    <TupleInner
                        flightSchedule={flightSchedule}
                        fareDetails={fareDetails}
                        fareRules={this.rules}
                        clubbed={this.props.clubbed}
                        switchTab={this.switchTabHandler}
                        tabIndex={this.state.tabIndex}
                        airlineNames={this.props.airlineNames}
                        cityNames={this.props.cityNames}
                        airportNames={this.props.airportNames}
                        isIntFlight={this.props.isIntFlight}
                    />
                </AnimakitExpander>
            </React.Fragment>
        )
    }
};

const mapStateToProps = state => {
    return {
        flightScheduleOnward: state.farePrice.flightScheduleOneWay,
        flightScheduleReturn: state.farePrice.flightScheduleRoundTrip,
        fareDetailsOnward: state.farePrice.fareSummaryOneWay,
        fareDetailsReturn: state.farePrice.fareSummaryRoundTrip,
        tduOnward: state.farePrice.tduOnward,
        loaOnward: state.farePrice.loaOnward,
        tduReturn: state.farePrice.tduReturn,
        loaReturn: state.farePrice.loaReturn,
        cityNames: state.farePrice.generalData.data.cityNames,
        airlineNames: state.farePrice.generalData.data.airlineNames,
        airportNames: state.farePrice.generalData.data.airportNames,
        searchId: state.farePrice.generalData.searchId,
        origin: state.farePrice.generalData.data.org,
        destination: state.farePrice.generalData.data.dest,
        rulesCounter: state.fareRules.counter,
        fareRules: state.fareRules.fareRules,
        farePrice: state.farePrice.farePrice,
        isIntFlight: state.farePrice.generalData.countryCodes.origin !== 'IN' || state.farePrice.generalData.countryCodes.dest !== 'IN',
        idac: state.farePrice.idac,
        iaac: state.farePrice.iaac
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getFareRules(fareRuleParams, flightId)),
        onGetIntFareRules: (fareRuleParams, flightId) => dispatch(fareRuleActions.getIntFareRules(fareRuleParams, flightId)),
        onGetBaggageInfo: (baggageParams) => dispatch(fareRuleActions.getBaggageInfo(baggageParams))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TupleStacked));


// WEBPACK FOOTER //
// ./src/components/Flight/TupleStacked/TupleStacked.js